import React from 'react';
import { Target, Sparkles, Zap, ArrowRight } from 'lucide-react';
import SectionWrapper from './SectionWrapper';
import { Button } from '../ui/Button';
import { Link } from 'react-router-dom';

export const FeaturesSection: React.FC = () => {
  return (
    <SectionWrapper>
      {/* Atmospheric lighting effects */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-primary-500/15 blur-[100px] -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-blue-500/15 blur-[100px] -z-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-4 text-gray-950">
          Built for Disciplined Traders (or Soon to <span className="gradient-text">Be</span>)
        </h2>
        <p className="text-lg text-center text-gray-700 max-w-3xl mx-auto mb-4">
          Get immediate visual feedback on your trading decisions. Reinforce positive habits daily.
        </p>
        <p className="text-xl text-center text-gray-700 max-w-2xl mx-auto mb-16">
          The Name of the Game? Stack those "Plan Followed" Days in your calendar ! The rest will take care of itself !
        </p>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="glass-card p-8 rounded-xl hover-card shadow-lg hover:shadow-xl transition-shadow">
            <div className="bg-gray-100 rounded-xl w-14 h-14 flex items-center justify-center mb-6">
              <Target className="text-gray-700" size={24} />
            </div>
            <h3 className="text-xl font-display font-semibold mb-3 text-gray-950">Process Over Profit</h3>
            <p className="text-gray-700 leading-relaxed">
              Build momentum by maintaining consecutive days of disciplined trading.
            </p>
          </div>
          
          <div className="glass-card p-8 rounded-xl hover-card shadow-lg hover:shadow-xl transition-shadow">
            <div className="bg-gray-100 rounded-xl w-14 h-14 flex items-center justify-center mb-6">
              <Sparkles className="text-gray-700" size={24} />
            </div>
            <h3 className="text-xl font-display font-semibold mb-3 text-gray-950">AI Powered Feedback</h3>
            <p className="text-gray-700 leading-relaxed">
              Get immediate visual feedback on your trading decisions and get AI Powered analysis based on your trades data.
            </p>
          </div>
          
          <div className="glass-card p-8 rounded-xl hover-card shadow-lg hover:shadow-xl transition-shadow">
            <div className="bg-gray-100 rounded-xl w-14 h-14 flex items-center justify-center mb-6">
              <Zap className="text-gray-700" size={24} />
            </div>
            <h3 className="text-xl font-display font-semibold mb-3 text-gray-950">Easy Journaling</h3>
            <p className="text-gray-700 leading-relaxed">
              This design ensures traders can focus on their performance without navigating through cluttered layouts.
            </p>
          </div>
        </div>
        
        <div className="flex justify-center mt-12">
          <Button 
            as={Link} 
            to="/trial" 
            size="lg" 
            className="!rounded-full px-12 py-6 text-xl font-semibold min-w-[240px] shadow-lg hover:shadow-xl flex items-center justify-center bg-black hover:bg-gray-900 text-white transition-all duration-300 animate-float shadow-glow"
          >
            Free Trial
            <ArrowRight size={24} className="ml-3" />
          </Button>
        </div>
      </div>
    </SectionWrapper>
  );
};